import React, { useCallback } from "react";
import CheckLogin from "../../components/common/CheckLogin";
import usePricingScrollOnLoad from "../../hooks/usePricingScrollOnLoad";
import { scrollToPricingSection } from "../../utils/scrollToPricing";
import { Page, HomepageGlobalStyles } from "./styles";
import Header from "./sections/Header";
import Hero from "./sections/Hero";
import AnalystTeam from "./sections/AnalystTeam";
import TrackRecord from "./sections/TrackRecord";
import Features from "./sections/Features";
import HomepagePricing from "./sections/HomepagePricing";
import AnalystStrip from "./sections/AnalystStrip";
import Footer from "./sections/Footer";

const Homepage = () => {
  const scrollToPricing = useCallback(() => {
    scrollToPricingSection();
  }, []);

  usePricingScrollOnLoad();

  return (
    <Page>
      <HomepageGlobalStyles />
      <CheckLogin />
      <Header onSubscribeClick={scrollToPricing} />
      <Hero onSubscribeClick={scrollToPricing} />
      <AnalystTeam onSubscribeClick={scrollToPricing} />
      <TrackRecord />
      <Features />
      <HomepagePricing />
      <AnalystStrip />
      <Footer onSubscribeClick={scrollToPricing} />
    </Page>
  );
};

export default Homepage;
